export default __webpack_public_path__ + "static/media/magazine2.4e73ed4a.png";